module.exports = __webpack_public_path__ + "MaterialIcons-Regular.570eb83859dc23dd0eec.woff2";


//////////////////
// WEBPACK FOOTER
// C:/carlos/wks/web/vacios_web/node_modules/material-design-icons/iconfont/MaterialIcons-Regular.woff2
// module id = ../../../../material-design-icons/iconfont/MaterialIcons-Regular.woff2
// module chunks = styles